import { createRouter, createWebHashHistory } from 'vue-router'
import Cart from './components/Cart.vue'
import Customer from './components/Customer.vue'
import Payment from './components/Payment.vue'
import ThankYou from './components/ThankYou.vue'
import Checkout from './components/Checkout.vue'
import CashDiscountSelector from './components/CashDiscountSelector.vue'
import OrderPayment from './components/OrderPayment.vue'

const Empty = { render: () => null };

const routes = [
  { path: '/',              name: 'home',    component: Empty },
  { path: '/product/:id',   name: 'product', component: Empty },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Catalog
  // },
  // {
  //   path: '/product/:id',
  //   name: 'product',
  //   component: Catalog
  // },
  {
    path: '/order-payment/:id',
    component: OrderPayment,
    name: 'orderpayment',
    meta: {
      modal: 'checkoutModal',
    },
  },
  {
    path: '/cart/',
    component: Cart,
    name: 'cart',
    meta: {
      modal: 'checkoutModal',
    },
  },
  {
    path: '/customer/',
    component: Customer,
    name: 'customer',
    meta: {
      modal: 'checkoutModal',
    },
  },
  {
    path: '/checkout/',
    component: Checkout,
    name: 'checkout',
    meta: {
      modal: 'checkoutModal',
    },
  },
  {
    path: '/payment-options/',
    component: CashDiscountSelector,
    name: 'paymentoptions',
    meta: {
      modal: 'checkoutModal',
    },
  },
  {
    path: '/thank-you/',
    component: ThankYou,
    name: 'thanks',
    meta: {
      modal: 'checkoutModal',
    },
  },
  {
      path: '/checkout/order',
      component: Payment,
      name: 'order',
      meta: {
        modal: 'checkoutModal',
      },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/cart/'
  },
  // {
  //   path: '/items/:id/',
  //   beforeEnter: [ keepDefaultView ],
  //   // component: ItemModal,
  // },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});


export default router
